import { render, staticRenderFns } from "./TCard.vue?vue&type=template&id=29c09ed6"
import script from "./TCard.vue?vue&type=script&lang=js"
export * from "./TCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports